export const WORKSPACE = 'workspace';
export const MODAL = 'modal';
export const EDITOR_TAB = 'Editor tab';
export const COLLECTION_BROWSER = 'Collection Browser';
export const RIGHT_OVERLAY_MODAL = 'Right Overlay Modal';
export const EDITOR_SUB_VIEW = 'editorSubView';
export const HOME = 'home';
export const OPEN_INTEGRATIONS_HOME_URL = 'integrations';

export const VIEW_IN_FOREGROUND = 'viewInForeground';
export const VIEW_IN_BACKGROUND = 'viewInBackground';

export const validViews = [
  HOME,
  OPEN_INTEGRATIONS_HOME_URL,
  WORKSPACE,
  EDITOR_TAB,
  COLLECTION_BROWSER,
  RIGHT_OVERLAY_MODAL,
  MODAL
];

export const validEvents = [
  VIEW_IN_FOREGROUND,
  VIEW_IN_BACKGROUND
];
